module.exports = __webpack_public_path__ + "img/banner.caa32902.png";